import { createFileRoute } from '@tanstack/react-router'

// The leaf that makes the pathless `_list` layout match on bare `/account/api/$appId/applicants`; it renders nothing.
export const Route = createFileRoute('/_app/account/api/$appId/applicants/_list/')({})
